<template>
    <VJoyDialog
        ref="dialogRef"
        :pattern-brand="true"
        :cancel-text="$t('search.service-level.profile-views.abuse-dialog.cancel')"
        data-testid="profile-views-abuse-dialog"
    >
        <template #dialog-header>
            {{ $t('search.service-level.profile-views.abuse-dialog.title') }}
        </template>
        <template #dialog-subheader>
            {{ $t('search.service-level.profile-views.abuse-dialog.subtitle') }}
        </template>
        <template #dialog-body>
            <MaltImg src="/hopsearch/service-levels/lost-illustration.svg" alt="Lost illustration" width="200" />
        </template>
        <template #dialog-confirm>
            <VJoyButton data-testid="profile-views-abuse-dialog-confirm" variant="main" :href="`mailto:${abuseContactEmail}`">
                {{ $t('search.service-level.profile-views.abuse-dialog.cta') }}
            </VJoyButton>
        </template>
    </VJoyDialog>
</template>

<script setup lang="ts">
    import {onMounted, ref} from 'vue';
    import {storeToRefs} from 'pinia';
    import {MaltImg} from '#components';
    import {useDataTracking} from '#imports';
    import {VJoyDialog, VJoyButton} from '@maltjoy/core-vue';
    import {useUserInfo} from '~/composables/useUserInfo';
    import {useProfileViews} from './useProfileViews';
    import {useSearchUrlStore} from '../stores/search-url.store';

    const dialogRef = ref<InstanceType<typeof VJoyDialog> | null>(null);

    const searchUrlStore = useSearchUrlStore();
    const {searchUrlParams} = storeToRefs(searchUrlStore);
    const {abuseSuspected, abuseContactEmail} = useProfileViews();
    const {track} = useDataTracking();
    const {serviceLevel} = useUserInfo();
    const {profileViewsStatus} = useProfileViews();

    function openDialog() {
        dialogRef.value?.show();
        track('profile_views_limit_reached', {
            threshold_reached: profileViewsStatus.value?.limit,
            current_service_level: serviceLevel.value,
        });
    }

    onMounted(() => {
        if (searchUrlParams.value.rejectReason === 'profile-views-limit' && abuseSuspected.value) {
            openDialog();
        }
    });
</script>
